import axios from "axios";

export async function getClientById(client_id, additionalFields = [])
{
    const params = {
        additional_fields: additionalFields,
    }
    return await new Promise((resolve, reject) => {
        axios.get(
            `/api/v1/clients/${client_id}`, {
                params: params
            }
        ).then(response => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    });
}
